// Modals
export const BASE_MODAL_Z_INDEX = 1300;
export const AUTH_MODAL_Z_INDEX = 1500;
export const FEEDBACK_MODAL_Z_INDEX = 1600;

// Other components
export const AUTOCOMPLETE_Z_INDEX = 1700;
export const TOAST_Z_INDEX = 1800;
